//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import * as MainConstants from "../../utils/MainConstants";
import { bindActionCreators } from "redux";
import { deleteAVehicle, loadVehiclesData, saveAVehicle, updateAVehicle } from "../../redux/modules/vehicle";
import { deleteAPolice, loadPoliceData, saveAPolice, updateAPolice } from "../../redux/modules/police";
import { saveATowjob } from "../../redux/modules/towjob";
import { saveAFax } from "../../redux/modules/fax";
import { loadCompanysData, selectACompany } from "../../redux/modules/company";
import { loadCompanypropertysData } from "../../redux/modules/companyproperty";
import { loadStoragelotsData } from "../../redux/modules/storagelot";
import { loadSingleUserData, loadUsersData } from "../../redux/modules/user";
import { decodeVin } from "../../redux/modules/vin";
import { loadPdfFile } from "../../redux/modules/pdf";
import { loadMessagesData, saveAMessage } from "../../redux/modules/message";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import {CREDIT_CARD_PROCESSING_FAILED_STATE, DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import TextField from '@material-ui/core/TextField';
import ExpandableMessage from "./ExpandableMessage";
import GridList from "@material-ui/core/GridList";
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import ListSubheader from '@material-ui/core/ListSubheader';
import fragment from "hls.js/src/loader/fragment";

const styles = theme => ({
	main: {
		width: 'auto',
		display: 'block', // Fix IE 11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400,
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	paper: {
		marginTop: theme.spacing.unit * 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing.unit,
	},
	submit: {
		marginTop: theme.spacing.unit * 3,
	},
	formControl: {
		margin: theme.spacing.unit,
		minWidth: 120,
	},
	selectEmpty: {
		marginTop: theme.spacing.unit * 2,
	},
	button: {
		marginTop: theme.spacing.unit * 3,
		marginLeft: theme.spacing.unit,
		backgroundColor: "#e2580d",
		color: "black",
		textTransform: "unset !important",
	},
	
	gridList: {
		//width:1200,
		height: 400,
	},
	dividerColor: {
		//marginTop: theme.spacing.unit * 3,
		color: "#e2580d",
		backgroundColor: "#e2580d",
	},
	dividerColorPurpole: {
		//marginTop: theme.spacing.unit * 3,
		color: "#760eb3",
		backgroundColor: "#760eb3",
	},
	dividerColor1: {
		//marginTop: theme.spacing.unit * 3,
		color: "#ddedbb",
		backgroundColor: "#ddedbb",
	},
	switchColor: {
		//marginTop: theme.spacing.unit * 3,
		color: "#e2580d",
		//backgroundColor:"#ddedbb",
	},
	panelheading: {
		fontSize: theme.typography.pxToRem(15),
		flexBasis: '33.33%',
		flexShrink: 0,
	},
	panelsecondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: theme.palette.text.secondary,
	},
	typoTopMargin: {
		marginTop: '40',
	},
	lowMargin: {
		marginTop: '10',
	},
	
	detailTitle: {
		textDecoration: 'underline'
	},
});


//'url(' + require('../../images/IMG_1.JPG')
class TextVehicleOwner extends React.Component {
	
	constructor(props) {
		super(props);
		this.handleActionChange = this.handleActionChange.bind(this);
		this.handleActionSubmit = this.handleActionSubmit.bind(this);
		this.getListOfMessage = this.getListOfMessage.bind(this);
		this.extractTheVehicleInformationFromTowJob = this.extractTheVehicleInformationFromTowJob.bind(this);
		this.getAvailableAction_oldone = this.getAvailableAction_oldone.bind(this);
		this.getAvailableAction = this.getAvailableAction.bind(this);
		this.translateTheStatus = this.translateTheStatus.bind(this);
		this.translateTheAction = this.translateTheAction.bind(this);
		this.handleTowFeeChange = this.handleTowFeeChange.bind(this);
		this.getListOfExpandableMessage = this.getListOfExpandableMessage.bind(this);
		this.getTotalAmountAndTime = this.getTotalAmountAndTime.bind(this);
		this.renderTheTowStoragelot = this.renderTheTowStoragelot.bind(this);
		this.renderPlateLocationStoragelot = this.renderPlateLocationStoragelot.bind(this);
		this.handleExtraTimeChange = this.handleExtraTimeChange.bind(this);
		this.handleExtraFeeChange = this.handleExtraFeeChange.bind(this);
		this.translateTheActionText = this.translateTheActionText.bind(this);
		this.translateTheWho = this.translateTheWho.bind(this);
		
		
		
		
		
		
		
		
		this.totalAmount = "";
		this.totalDuration = "";
		this.message = "";
		
		
		
		
		
		
		
		
		
		
		
	}
	
	state = {
		selectedActionOne: "Select One",
		passedTowJob: {},
		towfee: "",
		duration:"",
		extratime: "",
		extrafee: "",
		
	}
	
	handleActionChange(event) {
		this.message = "";
		this.setState({ selectedActionOne: event.target.value });
		if (event.target.value == "ta0_action_to_needs_to_be_towed") {
			this.message = "The vehicle needs to be towed.";
		} else if (event.target.value == "ta1_action_to_urgent_tow") {
			this.message = "There is no time to communicate with the vehicel owner. This vehicle will be towed immdeiately.	";
		} else if (event.target.value == "ta2_action_to_notified_immediate") {
			this.message = "This vehicle will be towed after 10 minutes. Vehicle ower has 10 minutes to move the vehicle.	";
		} else if (event.target.value == "ta3_action_to_notified_time_extension") {
			this.message = "This vehicle will be towed after 10 minutes. Vehicle ower has 10 minutes to move the vehicle. Please note that there is an option for extra time.	";
		} else if (event.target.value == "ta5_action_to_extra_time_granted") {
			this.message = "This vehicle will be towed after " + this.totalDuration
				+ " time minutes. Vehicle ower has  "+ this.totalDuration + " minutes to move the vehicle.";
		} else if (event.target.value == "ta6_action_to_moved_by_owner") {
			this.message = "The vehicle was moved by the vehicle owner/driver.	";
		} else if (event.target.value == "ta8_action_to_towed_truck_storage") {
			this.message = "This vehicle is store in storagelot.	";
		} else if (event.target.value == "ta9_action_to_pending_extra_time_granted") {
			this.message = "ta9_action_to_pending_extra_time_granted, extra time is granted and we are going to the new time count down.	";
		} else if (event.target.value == "vo1_cannot_move_action") {
			this.message = "I ,as the driver of the above vehicle, cannot move my vehicle at this time. I will pick up my vehicle from the tow company's storagelot.	";
		} else if (event.target.value == "vo2_accepted_one_time_extension_action") {
			this.message = "I, as the driver of the above vehicle, will move my vehicle within these " + this.totalDuration +" minutes. If not, the tow agent can tow my vehicle. I understand that I have already been charged $" + this.totalAmount;
		} else if (event.target.value == "vo3_cannot_move_action") {
			this.message = "I ,as the driver of the above vehicle, cannot move my vehicle at this time. I will pick up my vehicle from the tow company's storagelot.	";
		} else if (event.target.value == "vo4_accepted_multi_time_extension_action") {
			this.message =  "I, as the driver of the above vehicle, will move my vehicle within these " + this.totalDuration +" minutes. If not, the tow agent can tow my vehicle. I understand that I have already been charged $" + this.totalAmount;
		} else {
			this.message = "?????????";
		}
		
	};//End -> handleActionChange
	
	handleActionSubmit(event) {
		let { saveAMessage, loadMessagesData } = this.props;
		var currentState = "";
		var message = {};
		var currentMessages = this.props.messagesArray;
		if (currentMessages != null) {
			if (currentMessages.length > 0) {
				var tempmessage = currentMessages[currentMessages.length - 1];
				currentState = tempmessage.state;
			}
			
		}
		message.senderid = this.props.saveUserResp.id;
		message.vehicleid = this.state.passedTowJob.vehiclevin;
		message.gpslatitude = "gpslatitude";
		message.gpslongitude = "gpsLongitude";
		message.messagetime = new Date();
		message.messagetext = this.message;
		message.messagepicture = "MyMessagePicture";
		message.sendergroupid = "MyGroupId";
		message.cctransactionid = "MyTransactionID";
		message.notifieraddress = "MyNotifyerAddress";
		message.usertype = 1; //One means that the user is the tow truck agent.
		message.vehicleplatenumber = this.props.passedTowJob.vehicleplatenumber + " - " + this.props.passedTowJob.vehiclestate;
		message.vehiclelocation = this.props.passedTowJob.locationaddress1 + " - " + this.props.passedTowJob.locationaddress2 + this.props.passedTowJob.locationcity + ", " + this.props.passedTowJob.locationstate + " " + this.props.passedTowJob.locationzipcode;
		
		message.storagelot = this.props.passedTowJob.towcompanyname + " " + this.props.passedTowJob.storagelotaddress1 + " " + this.props.passedTowJob.storagelotcity + ", " + this.props.passedTowJob.storagelotstate + " " + this.props.passedTowJob.storagelotzipcode + "Phone: " + this.props.passedTowJob.storagelotphone;
		message.state = currentState;
		message.duration = this.totalDuration;
		message.basetowfee = this.state.towfee;
		message.extratimefee = this.state.extrafee;
		message.extratimeallowed = this.state.extratime;
		message.actionTaken = this.state.selectedActionOne;
		
		//?Farshid not ehere, please pay attention. I need to build and action and set up the to-STATE_TO-.
		var action = {};
		action.name = this.state.selectedActionOne;
		//action.toState = "towed_to_company_storage_lot_state";
		action.toState = "";
		action.eligiableUserType = 1;
		action.hrefLink = "hrefLink";
		message.selectedAction = action;
		message.towid = "";
		if ((this.props.passedTowJob != null) && (this.props.passedTowJob != 'undefined')) {
			message.towid = this.props.passedTowJob.id;
		}
		
		
		
		var argVehicle = this.extractTheVehicleInformationFromTowJob(this.props.passedTowJob);
		argVehicle.id = argVehicle.vin+argVehicle.platenumber+argVehicle.state;
		message.vehicleid = argVehicle.id;
		// Farshid loadMessagesData(DEFAULT_VESPAAN_SERVER.url, argVehicle, this.props.passedTowJob.id);
		saveAMessage(DEFAULT_VESPAAN_SERVER.url, message, argVehicle, this.props.passedTowJob.id );
		
		//This is to reload the messages again, after the new one was saved.
		//I am doing teh message reload as part of teh save message. now.
		/*if ((this.props.passedTowJob != null) && (this.props.passedTowJob != 'undefined')) {
			//if (this.props.passedTowJob.reasoncause != null) {
			//this.setState({passedTowJob: this.props.passedTowJob});
			var argVehicle = this.extractTheVehicleInformationFromTowJob(this.props.passedTowJob);
			argVehicle.id = argVehicle.vin;
			loadMessagesData(DEFAULT_VESPAAN_SERVER.url, argVehicle, this.props.passedTowJob.id);
			//}
		}*/
	}
	
	componentWillReceiveProps(nextProps) {
		let { loadMessagesData } = this.props;
		if (this.props.passedTowJob !== nextProps.passedTowJob) {
			if ((nextProps.passedTowJob != null) && (nextProps.passedTowJob != 'undefined')) {
				if (nextProps.passedTowJob.reasoncause != null) {
					this.setState({ passedTowJob: nextProps.passedTowJob });
					var argVehicle = this.extractTheVehicleInformationFromTowJob(nextProps.passedTowJob);
					argVehicle.id = argVehicle.vin+argVehicle.platenumber+argVehicle.state;
					loadMessagesData(DEFAULT_VESPAAN_SERVER.url, argVehicle, nextProps.passedTowJob.id);
				}
			}
		}
	}
	
	extractTheVehicleInformationFromTowJob(returnTowjob) {
		
		let { decodeVin } = this.props;
		let tempVehicleInfo = {};
		tempVehicleInfo.id = returnTowjob.vehicleid;
		tempVehicleInfo.model = returnTowjob.vehiclemodel;
		tempVehicleInfo.make = returnTowjob.vehiclemake;
		tempVehicleInfo.year = returnTowjob.vehicleyear;
		tempVehicleInfo.color = returnTowjob.vehiclecolor;
		tempVehicleInfo.platenumber = returnTowjob.vehicleplatenumber;
		tempVehicleInfo.state = returnTowjob.vehiclestate;
		tempVehicleInfo.vin = returnTowjob.vehiclevin;
		tempVehicleInfo.country = returnTowjob.vehiclecountry;
		
		return tempVehicleInfo;
	}
	
	componentWillMount() {
		// let {loadSingleUserData, loadUsersData, loadVehiclesData ,loadPoliceData, loadLocationsData,loadCompanysData, loadPdfFile  } = this.props;
		
		let { loadMessagesData } = this.props;
		var argVehicle = this.extractTheVehicleInformationFromTowJob(this.props.passedTowJob);
		argVehicle.id = argVehicle.vin+argVehicle.platenumber+argVehicle.state;
		
		
		loadMessagesData(DEFAULT_VESPAAN_SERVER.url, argVehicle, this.props.passedTowJob.id);
		
		this.setState({ passedTowJob: this.props.passedTowJob });
		
		/*if((this.props.companysArray != null)  && (this.props.companysArray.length >= 1) ){
			this.setState({selectedCompany: this.props.companysArray[0]});
		}*/
		this.setState({ errorCMsg: {} });
		//loadPdfFile(DEFAULT_VESPAAN_SERVER.url);
		
		
	}
	
	/* public static final String NOT_REGISTERED_WITH_PLATEWIZ_STATE = "not_registered_with_platewiz_state";
	 public static final String REGISTERED_WITH_PLATEWIZ_STATE = "registered_with_platewiz_state";
	 public static final String NOTIFIED_IMMEDIATE_ONETIME_EXTENSION_STATE = "notified_immediate_onetime_extention_state";
	 public static final String NOTIFIED_MULTIPLE_TIME_EXTENSION_STATE = "notified_multiple_time_extension_state";
	 //public static final String URGENT_TOW_STATE = "urgent_tow_state";
	 public static final String EXTRA_TIME_SELECTED_STATE = "extra_time_selected_state";
	 public static final String EXTRA_TIME_GRANTED_STATE = "extra_time_granted_state";
	 public static final String PENDING_STATE = "pending_state";
	 public static final String MOVED_BY_OWNER_STATE = "moved_by_owner_state";
	 public static final String NEEDS_TO_BE_TOWED_STATE = "needs_to_be_towed_state";
	 public static final String TOWED_COMPANY_STORAGE_LOT_STATE = "towed_to_company_storage_lot_state";
	 */
	
	
	translateTheStatus(argStatus) {
		//Fix this later.
		
		//var returnStatusInText = argStatus;
		
		var returnStatusInText;
		
		switch (argStatus) {
			
			case MainConstants.VEHICLE_NOT_REGISTERED_WITH_PLATEWIZ_STATE:
				returnStatusInText = "NOT in TowWatch";
				break;
			case MainConstants.VEHICLE_REGISTERED_WITH_PLATEWIZ_STATE:
				returnStatusInText = "In TowWatch";
				break;
			case MainConstants.VEHICLE_IS_COMMUNITY_VIP_STATE:
				returnStatusInText = "Community VIP";
				break;
			case MainConstants.VEHICLE_IS_COMMUNITY_MEMBER_STATE:
				returnStatusInText = "Community Member";
				break;
			case MainConstants.COMMUNITY_BASE_TIME_STATE:
				returnStatusInText = "Community Base Time";
				break;
			case MainConstants.COMMUNITY_URGENT_TOW_STATE:
				returnStatusInText = "Community Urgent Tow";
				break;
			case MainConstants.BASE_TIME_STATE:
				returnStatusInText = "Base Time";
				break;
			case MainConstants.EXTENDED_TIME_STATE:
				returnStatusInText = "Extended Time";
				break;
			case MainConstants.PENDING_CAN_MOVE_BASE_TIME:
				returnStatusInText = "Pending base time";
				break;
			case MainConstants.PENDING_CAN_MOVE_EXTRA_TIME:
				returnStatusInText = "Pending extended time";
				break;
			case MainConstants.COMMUNITY_PENDING_CAN_MOVE_BASE_TIME:
				returnStatusInText = "Community Base Pending";
				break;
			case MainConstants.VEHICLE_REMOVED_BY_OWNER_STATE:
				returnStatusInText = "Removed by owner";
				break;
			case MainConstants.TOW_VEHICLE_STATE:
				returnStatusInText = "Needs to be towed";
				break;
			case MainConstants.VEHICLE_BEING_TOWED_STATE:
				returnStatusInText = "Towing";
				break;
			case MainConstants.COMMUNITY_VEHICLE_BEING_TOWED_STATE:
				returnStatusInText = "Towing";
				break;
			case MainConstants.STORED_IN_STORAGE_LOT_STATE:
				returnStatusInText = "Stored in Storage lot";
				break;
			case MainConstants.COMPLETE_STATE:
				returnStatusInText = "Complete";
				break;
			case MainConstants.CREDIT_CARD_PROCESSING_FAILED_STATE:
				returnStatusInText = "Credit card processing failed";
				break;
			case MainConstants.INVALID_STATE:
				returnStatusInText = "Invalid State";
				break;
			default:
				returnStatusInText = "Unknown State";
				break;
			
		}
		
		
		return returnStatusInText;
		
	}
	
	
	translateTheAction(argAction) {
		
		
		
		return argAction.displayName;
		
		
		
	}
	
	/*public static final int TOW_TRUCK_AGENT_USER_TYPE = 1;
	public static final int TOW_TRUCK_COMPANY_OWNER_USER_TYPE = 2;
	public static final int VEHICLE_DRIVER_USER_TYPE = 4;
	public static final int VEHICLE_OWNER_USER_TYPE = 8;
	public static final int PROPERTY_OWNER_USER_TYPE = 16;
	public static final int PROPERTY_AGENT_USER_TYPE = 32;
	*/
	
	
	
	translateTheWho (argWho){
		console.log("The agr who is "+ argWho + "  "  + (argWho & 16));
		var argWhoBinary = parseInt(argWho, 2);
		
		
		console.log("The agr who is  second one  "+ argWho + "  "  + (argWho & 16));
		var returnActionInText="TowWatch System";
		
		if(((argWhoBinary & 1 ) != 0) || ((argWhoBinary & 2 )!= 0)){
			returnActionInText ="Tow Agent";
		}
		if(((argWhoBinary & 4 ) != 0) || ((argWhoBinary & 8) != 0)){
			returnActionInText ="Vehicle Driver";
		}
		if(((argWhoBinary & 16) != 0) || ((argWhoBinary & 32) != 0)){
			returnActionInText ="Property Owner";
		}
		return  returnActionInText;
	}
	
	
	
	translateTheActionText(argAction){
		
		var returnActionInText="-";
		switch (argAction) {
			case MainConstants.TA0_ACTION_TO_NEEDS_TO_BE_TOWED :
				returnActionInText = MainConstants.DISPLAY_TA0_ACTION_TO_NEEDS_TO_BE_TOWED;
				break;
			case MainConstants.TA1_ACTION_TO_URGENT_TOW :
				returnActionInText = MainConstants.DISPLAY_TA1_ACTION_TO_URGENT_TOW ;
				break;
			case MainConstants.TA2_ACTION_TO_BASE_TIME :
				returnActionInText = MainConstants.DISPLAY_TA2_ACTION_TO_BASE_TIME;
				break;
			case MainConstants.TA3_ACTION_TO_EXTENDED_TIME:
				returnActionInText = MainConstants.DISPLAY_TA3_ACTION_TO_EXTENDED_TIME;
				break;
			
			case MainConstants.TA6_ACTION_TO_MOVED_BY_OWNER :
				returnActionInText = MainConstants.DISPLAY_TA6_ACTION_TO_MOVED_BY_OWNER;
				break;
			case MainConstants.TA7_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED :
				returnActionInText = MainConstants.DISPLAY_TA7_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED;
				break;
			case MainConstants.TA8_ACTION_TOWING_TO_STORAGE_LOT :
				returnActionInText = MainConstants.DISPLAY_TA8_ACTION_TOWING_TO_STORAGE_LOT;
				break;
			case MainConstants.TA8COM_ACTION_TO_COMMUNITY_VEHICLE_BEING_TOWED :
				returnActionInText = MainConstants.DISPLAY_TA8COM_ACTION_TO_COMMUNITY_VEHICLE_BEING_TOWED;
				break;
			case MainConstants.TA10_ACTION_TO_NOTIFY_VIP_MEMBER:
				returnActionInText = MainConstants.DISPLAY_TA10_ACTION_TO_NOTIFY_VIP_MEMBER;
				break;
			case MainConstants.TA11_ACTION_TO_COMMUNITY_URGENT_TOW :
				returnActionInText = MainConstants.DISPLAY_TA11_ACTION_TO_COMMUNITY_URGENT_TOW;
				break;
			case MainConstants.TA12_ACTION_TO_COMMUNITY_BASE_TIME :
				returnActionInText = MainConstants.DISPLAY_TA12_ACTION_TO_COMMUNITY_BASE_TIME;
				break;
			case MainConstants.TA13_ACTION_TO_COMMUNITY_MOVED_BY_OWNER :
				returnActionInText = MainConstants.DISPLAY_TA13_ACTION_TO_COMMUNITY_MOVED_BY_OWNER;
				break;
			case MainConstants.TA14_ACTION_TO_COMMUNITY_NEEDS_TO_BE_TOWED_TIMER_CANCELLED :
				returnActionInText = MainConstants.DISPLAY_TA14_ACTION_TO_COMMUNITY_NEEDS_TO_BE_TOWED_TIMER_CANCELLED;
				break;
			case MainConstants.TA15_ACTION_TO_VEHICLE_WAS_STORED_IN_STORAGE_LOT:
				returnActionInText = MainConstants.DISPLAY_TA15_ACTION_TO_VEHICLE_WAS_STORED_IN_STORAGE_LOT;
				break;
			case MainConstants.TA16_ACTION_TO_MOVED_BY_OWNER_EXTENDED_TIME :
				returnActionInText = MainConstants.DISPLAY_TA16_ACTION_TO_MOVED_BY_OWNER_EXTENDED_TIME;
				break;
			case MainConstants.TA17_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED_EXTENDED_TIME :
				returnActionInText = MainConstants.DISPLAY_TA17_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED_EXTENDED_TIME;
				break;
			case MainConstants.TA18_ACTION_TO_COMPLETE :
				returnActionInText = MainConstants.DISPLAY_TA18_ACTION_TO_COMPLETE ;
				break;
			case MainConstants.TIMER_EXPIRED_TO_NEEDS_TO_BE_TOWED:
				returnActionInText = MainConstants.DISPLAY_TIMER_EXPIRED_TO_NEEDS_TO_BE_TOWED;
				break;
			case MainConstants.VO1_ACTION_TO_CANNOT_MOVE:
				returnActionInText = MainConstants.DISPLAY_VO1_ACTION_TO_CANNOT_MOVE;
				break;
			case MainConstants.VO2_ACTION_TO_CAN_MOVE_VEHICLE_IN_BASE_TIME :
				returnActionInText = MainConstants.DISPLAY_VO2_ACTION_TO_CAN_MOVE_VEHICLE_IN_BASE_TIME;
				break;
			case MainConstants.VO3_ACTION_TO_CANNOT_MOVE :
				returnActionInText = MainConstants.DISPLAY_VO3_ACTION_TO_CANNOT_MOVE;
				break;
			case MainConstants.VO4_ACTION_TO_CAN_MOVE_VEHICLE_IN_EXTENDED_TIME :
				returnActionInText = MainConstants.DISPLAY_VO4_ACTION_TO_CAN_MOVE_VEHICLE_IN_EXTENDED_TIME;
				break;
			case MainConstants.VO5_ACTION_TO_EXTRA_TIME_SELECTED:
				returnActionInText = MainConstants.DISPLAY_VO5_ACTION_TO_EXTRA_TIME_SELECTED;
				break;
			case MainConstants.VO6_ACTION_TO_COMMUNITY_CANNOT_MOVE :
				returnActionInText = MainConstants.DISPLAY_VO6_ACTION_TO_COMMUNITY_CANNOT_MOVE;
				break;
			case MainConstants.VO7_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_BASE_TIME :
				returnActionInText = MainConstants.DISPLAY_VO7_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_BASE_TIME;
				break;
			case MainConstants.SE_ACTION_NONE :
				returnActionInText = MainConstants.DISPLAY_SE_ACTION_NONE;
				break;
			case MainConstants.SE0_ACTION_COMMUNITY_MEMBER :
				returnActionInText = MainConstants.DISPLAY_SE0_ACTION_COMMUNITY_MEMBER;
				break;
			case MainConstants.SE0_ACTION_COMMUNITY_VIP_MEMBER :
				returnActionInText = MainConstants.DISPLAY_SE0_ACTION_COMMUNITY_VIP_MEMBER;
				break;
			case MainConstants.SE1_ACTION_BASE_TIME_RESPONSE_TIME_EXPIRED:
				returnActionInText = MainConstants.DISPLAY_SE1_ACTION_BASE_TIME_RESPONSE_TIME_EXPIRED;
				break;
			case MainConstants.SE2_ACTION_EXTENDED_TIME_RESPONSE_TIME_EXPIRED:
				returnActionInText = MainConstants.DISPLAY_SE2_ACTION_EXTENDED_TIME_RESPONSE_TIME_EXPIRED;
				break;
			case MainConstants.SE3_ACTION_VO_SHOW_BASE_TIME_EXPIRED :
				returnActionInText = MainConstants.DISPLAY_SE3_ACTION_VO_SHOW_BASE_TIME_EXPIRED;
				break;
			case MainConstants.SE4_ACTION_VO_SHOW_EXTENDED_TIME_EXPIRED :
				returnActionInText = MainConstants.DISPLAY_SE4_ACTION_VO_SHOW_EXTENDED_TIME_EXPIRED;
				break;
			case MainConstants.SE5_ACTION_COMMUNITY_BASE_TIME_RESPONSE_TIME_EXPIRED :
				returnActionInText = MainConstants.DISPLAY_SE5_ACTION_COMMUNITY_BASE_TIME_RESPONSE_TIME_EXPIRED;
				break;
			case MainConstants.SE6_ACTION_VO_COMMUNITY_SHOW_BASE_TIME_EXPIRED:
				returnActionInText = MainConstants.DISPLAY_SE6_ACTION_VO_COMMUNITY_SHOW_BASE_TIME_EXPIRED;
				break;
			case MainConstants.SE7_ACTION_CREDIT_CARD_PROCESSING_FAILURE:
				returnActionInText = MainConstants.DISPLAY_SE7_ACTION_CREDIT_CARD_PROCESSING_FAILURE;
				break;
			case MainConstants.PISE0_ACTION_NOT_REGISTERED_WITH_PLATEWIZ:
				returnActionInText = MainConstants.DISPLAY_PISE0_ACTION_NOT_REGISTERED_WITH_PLATEWIZ
				break;
			case MainConstants.PISE1_ACTION_TOW_VEHICLE:
				returnActionInText = MainConstants.DISPLAY_PISE1_ACTION_TOW_VEHICLE
				break;
			case MainConstants.PISE2_ACTION_REGISTERED_WITH_PLATEWIZ:
				returnActionInText = MainConstants.DISPLAY_PISE2_ACTION_REGISTERED_WITH_PLATEWIZ
				break;
			case MainConstants.PISE3_ACTION_REGISTERED_WITH_PLATEWIZ_NOT_IN_COMMUNITY:
				returnActionInText = MainConstants.DISPLAY_PISE3_ACTION_REGISTERED_WITH_PLATEWIZ_NOT_IN_COMMUNITY;
				break;
			case MainConstants.PISE4_ACTION_COMMUNITY_GUEST:
				returnActionInText = MainConstants.DISPLAY_PISE4_ACTION_COMMUNITY_GUEST
				break;
			case MainConstants.PISE5_ACTION_COMMUNITY_RESIDENT:
				returnActionInText = MainConstants.DISPLAY_PISE5_ACTION_COMMUNITY_RESIDENT
				break;
			case MainConstants.PISE6_ACTION_COMMUNITY_BASE_TIME_RESPONSE_TIME_EXPIRED:
				returnActionInText = MainConstants.DISPLAY_PISE6_ACTION_COMMUNITY_BASE_TIME_RESPONSE_TIME_EXPIRED;
				break;
			case MainConstants.PISE7_ACTION_COMMUNITY_EXTENDED_TIME_RESPONSE_TIME_EXPIRED:
				returnActionInText = MainConstants.DISPLAY_PISE7_ACTION_COMMUNITY_EXTENDED_TIME_RESPONSE_TIME_EXPIRED;
				break;
			case MainConstants.PISE8_ACTION_COMMUNITY_BASE_TIME_CAN_MOVE_TIME_EXPIRED:
				returnActionInText = MainConstants.DISPLAY_PISE8_ACTION_COMMUNITY_BASE_TIME_CAN_MOVE_TIME_EXPIRED;
				break;
			case MainConstants.PISE9_ACTION_COUMMUNITY_CREDIT_CARD_PROCESSING_FAILURE:
				returnActionInText = MainConstants.DISPLAY_PISE9_ACTION_COMMUNITY_CREDIT_CARD_PROCESSING_FAILURE;
				break;
			case MainConstants.PISE10_ACTION_COMMUNITY_EXTENDED_TIME_CAN_MOVE_TIME_EXPIRED :
				returnActionInText = MainConstants.DISPLAY_PISE10_ACTION_COMMUNITY_EXTENDED_TIME_CAN_MOVE_TIME_EXPIRED;
				break;
			case MainConstants.PISE11_ACTION_COUMMUNITY_CREDIT_CARD_PROCESSING_SUCCESSFUL:
				returnActionInText = MainConstants.DISPLAY_SE7_ACTION_CREDIT_CARD_PROCESSING_FAILURE;
				break;
			case MainConstants.PITA1_ACTION_TO_COMMUNITY_URGENT_TOW:
				returnActionInText = MainConstants.DISPLAY_PITA1_ACTION_TO_COMMUNITY_URGENT_TOW;
				break;
			case MainConstants.PITA2_ACTION_TO_COMMUNITY_BASE_TIME:
				returnActionInText = MainConstants.DISPLAY_PITA2_ACTION_TO_COMMUNITY_BASE_TIME;
				break;
			case MainConstants.PITA3_ACTION_TO_COMMUNITY_EXTENDED_TIME:
				returnActionInText = MainConstants.DISPLAY_PITA3_ACTION_TO_COMMUNITY_EXTENDED_TIME;
				break;
			case MainConstants.PITA4_ACTION_TO_PENDING:
				returnActionInText = MainConstants.DISPLAY_PITA4_ACTION_TO_PENDING;
				break;
			case MainConstants.PITA5_ACTION_TO_EXTRA_TIME_SELECTED:
				returnActionInText = MainConstants.DISPLAY_PITA5_ACTION_TO_EXTRA_TIME_SELECTED;
				break;
			case MainConstants.PITA6_ACTION_TO_MOVED_BY_OWNER :
				returnActionInText = MainConstants.DISPLAY_PITA6_ACTION_TO_MOVED_BY_OWNER;
				break;
			case MainConstants.PITA7_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED:
				returnActionInText = MainConstants.DISPLAY_PITA7_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED;
				break;
			case MainConstants.PITA8_ACTION_ESCLATE_TO_TOW_VEHICLE:
				returnActionInText = MainConstants.DISPLAY_PITA8_ACTION_ESCLATE_TO_TOW_VEHICLE;
				break;
			case MainConstants.PITA15_ACTION_TO_CALL_TOW_COMPANY :
				returnActionInText = MainConstants.DISPLAY_PITA15_ACTION_TO_CALL_TOW_COMPANY;
				break;
			case MainConstants.PITA16_ACTION_TO_MOVED_BY_OWNER_EXTENDED_TIME:
				returnActionInText = MainConstants.DISPLAY_PITA16_ACTION_TO_MOVED_BY_OWNER_EXTENDED_TIME;
				break;
			case MainConstants.PITA17_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED_EXTENDED_TIME :
				returnActionInText = MainConstants.DISPLAY_PITA17_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED_EXTENDED_TIME;
				break;
			case MainConstants.PITA18_ACTION_TO_COMPLETE :
				returnActionInText = MainConstants.DISPLAY_PITA18_ACTION_TO_COMPLETE;
				break;
			case MainConstants.PIVO1_ACTION_TO_COMMUNITY_CANNOT_MOVE :
				returnActionInText = MainConstants.DISPLAY_PIVO1_ACTION_TO_COMMUNITY_CANNOT_MOVE;
				break;
			case MainConstants.PIVO2_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_BASE_TIME:
				returnActionInText = MainConstants.DISPLAY_PIVO2_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_BASE_TIME;
				break;
			case MainConstants.PIVO3_ACTION_TO_COMMUNITY_CANNOT_MOVE :
				returnActionInText = MainConstants.DISPLAY_PIVO3_ACTION_TO_CANNOT_MOVE;
				break;
			case MainConstants.PIVO4_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_EXTENDED_TIME :
				returnActionInText = MainConstants.DISPLAY_PIVO4_ACTION_TO_CAN_MOVE_VEHICLE_IN_EXTENDED_TIME;
				break;
			case MainConstants.PIVO5_ACTION_TO_COMMUNITY_EXTRA_TIME_SELECTED :
				returnActionInText = MainConstants.DISPLAY_PIVO5_ACTION_TO_EXTRA_TIME_SELECTED;
				break;
			default:
				returnActionInText = "Unknown Action";
		}
		return  returnActionInText;
		
		
		
	}
	
	/* Old one
		
		translateTheActionText(argAction){
		 
			 var returnActionInText="-"
			 switch(argAction){
			 
				 case "ta2_action_to_notified_immediate":
					 returnActionInText="to_notified_immediate_action";
					 break;
				 case "ta3_action_to_notified_time_extension":
					 returnActionInText="to_notified_time_extension_action";
					 break;
			 
				 case "to_extra_time_selected_action":
					 returnActionInText="to extra time selected action";
					 break;
			 
				 case "to_pending_action":
					 returnActionInText="to pending action";
					 break;
			 
				 case "to_moved_by_owner_action":
					 returnActionInText="to moved by owner action";
					 break;
			 
				 case "to_needs_to_be_moved_action":
					 returnActionInText="to needs to be moved action";
					 break;
			 
				 case "ta8_action_to_towed_truck_storage":
					 returnActionInText="to towed truck storage action";
					 break;
			 
				 case "to_extra_time_granted_action":
					 returnActionInText="to extra time granted action";
					 break;
			 
				 case "se_no_action":
					 returnActionInText="se no action";
					 break;
				
				 default:
					 returnActionInText=argAction;
					 break;
			 
			 }
			 return  returnActionInText;
			 
			 
			 
		 }
		 
		
	 */
	
	handleExtraFeeChange(event) {
		//event.preventDefault();
		/*if (event.target.value.length > 0) {
			this.setState({ plateHelperText: '', plateError: false });
			
		} else {
			this.setState({ plateHelperText: 'Required', plateError: true });
		}*/
		this.setState({ extrafee: event.target.value });
	}
	
	handleExtraTimeChange(event) {
		//event.preventDefault();
		/*if (event.target.value.length > 0) {
			this.setState({ plateHelperText: '', plateError: false });
			
		} else {
			this.setState({ plateHelperText: 'Required', plateError: true });
		}*/
		this.setState({ extratime: event.target.value });
	}
	handleTowFeeChange(event) {
		//event.preventDefault();
		/*if (event.target.value.length > 0) {
			this.setState({ plateHelperText: '', plateError: false });
			
		} else {
			this.setState({ plateHelperText: 'Required', plateError: true });
		}*/
		this.setState({ towfee: event.target.value });
	}
	
	getListOfExpandableMessage(argMessageList) {
		
		let tempArray = this.props.messagesArray;
		let tempArray2 = tempArray.filter(function (obj) { return obj != null });
		let returnArray = [];
		if (tempArray2) {
			
			
			returnArray = tempArray2.map((s) => {
				
				if (s != null) {
					return (
						<ExpandableMessage info={s} key={s.id} > </ExpandableMessage>);
				}
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
			
		}
		
		return (returnArray);
	}
	
	
	getListOfMessage(argMessageList) {
		
		let tempArray = this.props.messagesArray;
		let returnArray = [];
		let backgroundColor= "red";
		if (tempArray) {
			
			//	{this.translateTheActionText(s.actionTaken)}
			
			returnArray = tempArray.map((s, argIndex) => {
				if(argIndex % 2 === 0){
					backgroundColor ='#e0e9e9'
				}else{
					backgroundColor ='white'
				}
				var pdispatchtime = "---";
				if ((s.messagetime != null) || (s.messagetime != undefined)) {
					pdispatchtime = new Date(s.messagetime);
					var hour1 = pdispatchtime.getHours() % 12;
					var newformat1 = pdispatchtime.getHours() >= 12 ? 'PM' : 'AM';
					var minutes = pdispatchtime.getMinutes() < 10 ? '0' + pdispatchtime.getMinutes() : pdispatchtime.getMinutes();
					pdispatchtime = (pdispatchtime.getMonth() + 1) + "/" + pdispatchtime.getDate() + "/" + pdispatchtime.getFullYear() + " " + hour1 + ":" + minutes + " " + newformat1;
				}
				return (
					<Grid container spacing={24} style={{backgroundColor:backgroundColor, paddingLeft:10}}>
						{/*<Grid item xs={3} sm={3} align="left">
							 <Typography variant="body1" gutterBottom>
								{this.translateTheStatus(s.state)}
							</Typography>
						</Grid>*/}
						<Grid item xs={4} sm={4} align="left">
							<Typography variant="body1" gutterBottom>
								{pdispatchtime}
							</Typography>
						</Grid>
						
						<Grid item xs={4} sm={4} align="left">
							<Typography variant="body1" gutterBottom>
								{this.translateTheWho(s.usertype)}
							</Typography>
						</Grid>
						<Grid item xs={4} sm={4} align="left">
							<Typography variant="body1" gutterBottom>
								{this.translateTheActionText(s.actionTaken)}
							</Typography>
						</Grid>
						
					</Grid>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
			
		}
		
		return (returnArray);
	}
	
	getAvailableAction_oldone(argMessageList) {
		
		let tempArray = this.props.messagesArray;
		let lastElementArray = [];
		let returnArray = [];
		if ((tempArray != null) && (tempArray.length != 0)) {
			lastElementArray.push(tempArray[tempArray.length - 1]);
		}
		
		if ((lastElementArray != null) && (lastElementArray.length > 0)) {
			var actionNames = lastElementArray[0].actions.map((j) => {
				return (<p> {j.name}</p>)
			});
			
			returnArray = lastElementArray.map((s) => {
				return (
					<Grid container spacing={24}>
						
						
						<Grid item xs={4} sm={4} align="center">
							<Typography variant="h6" gutterBottom>
								{s.state}
							</Typography>
						</Grid>
						<Grid item xs={4} sm={4} align="center">
							<Typography variant="h6" gutterBottom>
								{actionNames}
							</Typography>
						</Grid>
						<Grid item xs={4} sm={4} align="center">
							<Typography variant="h6" gutterBottom>
								{s.senderid}
							</Typography>
						</Grid>
					</Grid>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
		}
		return (returnArray);
	}
	
	
	
	
	getAvailableAction(argMessageList) {
		
		let tempArray = this.props.messagesArray;
		let lastElementArray = [];
		let returnArray = [];
		if ((tempArray != null) && (tempArray.length != 0)) {
			lastElementArray.push(tempArray[tempArray.length - 1]);
		}
		
		if ((lastElementArray != null) && (lastElementArray.length > 0)) {
			var listOfActions = lastElementArray[0].actions;
			
			//with this filter we are getting only action related to the TA  Uncomment the following line Farshid
			listOfActions = listOfActions.filter(action => action.name.indexOf('ta') !== -1)
			returnArray = listOfActions.map((j) => {
				return (<MenuItem key={j.name} value={j.name}>{j.displayName}</MenuItem>)
			});
		}
		return (returnArray);
	}
	
	
	
	renderTheTowStoragelot() {
		return (<Typography variant="body1" gutterBottom> {this.props.passedTowJob.towcompanyname} <br /> {this.props.passedTowJob.storagelotaddress1}  <br />
			{this.props.passedTowJob.storagelotcity + ", " + this.props.passedTowJob.storagelotstate + " " + this.props.passedTowJob.storagelotzipcode} <br />
			Phone: { this.props.passedTowJob.storagelotphone}
		</Typography>);
	}
	
	
	
	
	
	
	renderPlateLocationStoragelot() {
		const { classes } = this.props;
		
		return (
			<Grid container spacing={24}>
				<Grid item xs={2} sm={2}>
					<Typography variant="subtitle1" style={{ display: 'inline-block' }} className={classes.detailTitle}>
						Plate Number:
					</Typography>
				</Grid>
				<Grid item xs={3} sm={3}>
					<Typography variant="body1"    >
						{this.props.passedTowJob.vehicleplatenumber} -{this.props.passedTowJob.vehiclestate}
					</Typography>
				</Grid>
				<Grid item xs={7} sm={7}>
				
				</Grid>
				<Grid item xs={12} sm={12} >
					<br />
				</Grid>
				
				
				<Grid item xs={2} sm={2}>
					<Typography variant="subtitle1" className={classes.detailTitle}>
						Vehicle Location:<br/>
					</Typography>
				</Grid>
				<Grid item xs={4} sm={4}>
					<Typography variant="body1" gutterBottom>
						{this.props.passedTowJob.locationaddress1 + " - " + this.props.passedTowJob.locationaddress2} <br />
						{this.props.passedTowJob.locationcity + ", " + this.props.passedTowJob.locationstate + " " + this.props.passedTowJob.locationzipcode} <br />
					</Typography>
				</Grid>
				{/*}
				<Grid item xs={8} sm={8}>
					
					</Grid>
				<Grid item xs={12} sm={12} >
				<br/>
				</Grid>*/}
				
				<Grid item xs={2} sm={2}>
					<Typography variant="subtitle1" className={classes.detailTitle}>
						Tow Storage:
					</Typography>
					<br/>
				</Grid>
				<Grid item xs={4} sm={4}>
					
					<Typography variant="body1" gutterBottom>
						{this.props.passedTowJob.towcompanyname} <br /> {this.props.passedTowJob.storagelotaddress1}  <br />
						{this.props.passedTowJob.storagelotcity + ", " + this.props.passedTowJob.storagelotstate + " " + this.props.passedTowJob.storagelotzipcode} <br />
						Phone: {this.props.passedTowJob.storagelotphone}
					</Typography>
				</Grid>
				{/*<Grid item xs={7} sm={7}>
					
					</Grid>*/}
				<Grid item xs={12} sm={12} >
					<br />
				</Grid>
			</Grid>
		
		);
	}
	
	
	
	
	
	
	getTotalAmountAndTime(argMessageList) {
		
		let tempArray = this.props.messagesArray;
		let lastElementArray = [];
		
		if ((tempArray != null) && (tempArray.length != 0)) {
			lastElementArray.push(tempArray[tempArray.length - 1]);
		}
		
		if ((lastElementArray != null) && (lastElementArray.length > 0)) {
			this.totalAmount = lastElementArray[0].basetowfee + lastElementArray[0].extratimefee;
			this.totalDuration = lastElementArray[0].duration + lastElementArray[0].extratimeallowed;
		}
		this.totalAmount = 100000;
		return;
	}
	
	
	
	
	
	
	
	
	
	render() {
		const { classes } = this.props;
		var lastMessage = null;
		var possibleActions = this.getAvailableAction();//MainConstants.getVehicleOwnerActionList();
		var listOfMessages = this.getListOfMessage();
		console.log("Message array size is " + this.props.messagesArray.length);
		console.log( this.props.messagesArray );
		if((listOfMessages != null) && (this.props.messagesArray.length > 0)) {
			lastMessage = this.props.messagesArray[this.props.messagesArray.length-1];
		}
		this.getTotalAmountAndTime();  //This function sets the totalAmout and totalTime
		var theTowStoragelot = this.renderTheTowStoragelot();
		var plateLocationStoragelot = this.renderPlateLocationStoragelot();
		console.log("Hey Farshid the this.state.selectedActionOne is " + this.state.selectedActionOne);
		//I need to work on this more it didn't come out right.
		//var listOfExpandabelMessages = this.getListOfExpandableMessage();
		//var availableAction = this.getAvailableAction_oldone();
		return (
			<React.Fragment>
				
				<Grid container spacing={24}>
					<Grid item xs={12} sm={12}>
						<Divider className={classes.dividerColor}></Divider>
					</Grid>
					<Grid item xs={2} sm={2}>
					
					</Grid>
					<Grid item xs={8} sm={8} align="center">
						<Typography variant="h6" gutterBottom  style={{   fontSize:'40', color: 'black' ,    flex:1 }}>
							Vehicle Owner Communications - {this.props.passedTowJob.privatepropertynumber}
						</Typography>
					</Grid>
					<Grid item xs={2} sm={2}>
					</Grid>
				</Grid>
				<br />
				{/*
                    <Grid container spacing={24}>
                    <Grid item xs={6} sm={6}>
                        <Divider className={classes.dividerColor}></Divider>
                    </Grid>

                    <Grid item xs={6} sm={6}>
                    <Divider className={classes.dividerColor}></Divider>
                    </Grid>
                    </Grid>
                        */}
				
				<Grid container spacing={24}  style={{ paddingBottom:20 }}>
					<Grid item xs={4} sm={4} align="center"  style={{ flexDirection:"row" }}>
						<Typography variant="body1" gutterBottom  style={{ display: 'inline-block',   color: 'black' , fontWeight:'bold', flex:1 }}>
							VIN:
						</Typography>
						<Typography variant="body1" gutterBottom  style={{ display: 'inline-block',   color: 'black' , paddingLeft:5, flex:1 }}>
							{this.props.passedTowJob.vehiclevin}
						</Typography>
					</Grid>
					<Grid item xs={4} sm={4} align="center" style={{ flexDirection:"row" }}>
						<Typography variant="body1" gutterBottom  style={{ display: 'inline-block',   color: 'black' , fontWeight:'bold', flex:1 }}>
							Plate:
						</Typography>
						<Typography variant="body1" gutterBottom  style={{ display: 'inline-block',   color: 'black' , paddingLeft:5,   flex:1 }}>
							{this.props.passedTowJob.vehicleplatenumber}
						</Typography>
					
					</Grid>
					
					<Grid item xs={4} sm={4} align="center"  >
						<span style={{ flexDirection:"row" }} >
						<Typography variant="body1" gutterBottom    style={{ display: 'inline-block',   color: 'black' , fontWeight:'bold', flex:1 }}>
							State:
						</Typography>
						<Typography variant="body1" gutterBottom style={{ display: 'inline-block',   color: 'black' ,  paddingLeft:5,  flex:1 }}>
							 {this.props.passedTowJob.vehiclestate}
						</Typography>
						</span>
					</Grid>
				
				</Grid>
				
				
				<Grid container spacing={24} style={{paddingLeft:10}}>
					{/*<Grid item xs={3} sm={3} align="left">
						<Typography variant="h6" gutterBottom  style={{ display: 'inline-block',   color: 'black' , fontWeight:'bold' }}>
							Status
						</Typography>
						<Divider className={classes.dividerColor}></Divider>
					</Grid>*/}
					
					<Grid item xs={4} sm={4} align="left">
						<Typography variant="h6" gutterBottom style={{ display: 'inline-block',   color: 'black' , fontWeight:'bold' }}>
							Time
						</Typography>
						<Divider className={classes.dividerColor}></Divider>
					</Grid>
					<Grid item xs={4} sm={4} align="left">
						<Typography variant="h6" gutterBottom style={{ display: 'inline-block',   color: 'black' , fontWeight:'bold' }}>
							Who
						</Typography>
						<Divider className={classes.dividerColor}></Divider>
					</Grid>
					<Grid item xs={4} sm={4} align="left">
						<Typography variant="h6" gutterBottom style={{ display: 'inline-block',   color: 'black' , fontWeight:'bold' }}>
							Actions
						</Typography>
						<Divider className={classes.dividerColor}></Divider>
					</Grid>
				</Grid>
				
				
				<Grid container spacing={24}>
					<Grid item xs={12} sm={12} align="left">
						<GridList cellHeight={50} className={classes.gridList} cols={1} >
							<GridListTile key="Subheader" cols={2} style={{ height: 'auto' }}>
								{/*<ListSubheader component="div">Message List</ListSubheader>*/}
							</GridListTile>
							{listOfMessages}
						</GridList>
						<div  style={{ textAlign:'center' }}>
							<Typography variant="h8" gutterBottom style={{ display: 'inline-block', alignSelf:'center',  color: 'black'  }}>
								VO = Vehicle Owner ,     TA = Tow Agent
							</Typography>
						</div>
					</Grid>
				</Grid>
				
				{/*{availableAction} */}
				<Grid container spacing={24}>
					<Grid item xs={12} sm={12} >
						<br />
						<br />
					</Grid>
				</Grid>
				<Divider className={classes.dividerColorPurpole}></Divider>
				<Grid container spacing={24}>
					<Grid item xs={4} sm={4} align="center">
						<Typography variant="h6" gutterBottom>
							Available Actions
						</Typography>
					</Grid>
					<Grid item xs={4} sm={4} >
						<FormControl className={classes.formControl}>
							
							{(possibleActions.length !== 0) && (
								<div>
									<InputLabel htmlFor="age-helper">Select Action</InputLabel>
									<Select value={this.state.selectedActionOne}
									        onChange={this.handleActionChange}
									        inputProps={{
										        name: 'action',
										        id: 'action-helper',
									        }}>
										{possibleActions}
									</Select>
								</div>)}
							{(possibleActions.length === 0) && (lastMessage !== null) && (lastMessage.state !== MainConstants.COMPLETE_STATE) &&(
								<InputLabel htmlFor="age-helper">No Action available, waiting for the other party to respond.</InputLabel>
							)}
							{(possibleActions.length === 0) && (lastMessage !== null) && (lastMessage.state === MainConstants.COMPLETE_STATE) &&(
								<InputLabel htmlFor="age-helper">No more action available, messaging is complete.</InputLabel>
							)}
						</FormControl>
					</Grid>
					<Grid item xs={4} sm={4} >
					
					</Grid>
				</Grid>
				{/* ta0_action_to_needs_to_be_towed */}
				{(this.state.selectedActionOne == "ta0_action_to_needs_to_be_towed") && (<Grid container spacing={24}>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Vehicle Driver/Owner
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1" >
								{this.message}
							</Typography>
						</Grid>
						
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6" gutterBottom>
								The driver's credit card  is charged  ${this.totalAmount}
							</Typography>
						</Grid>
					
					</Grid>
				)}
				{/* ta1_action_to_urgent_tow */}
				{(this.state.selectedActionOne == "ta1_action_to_urgent_tow") && (<Grid container spacing={24}>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Vehicle Driver/Owner.
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1"  gutterBottom>
								{this.message}
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={3} sm={3}>
							<Typography variant="h6" gutterBottom>
								Towing Charges:  $
							</Typography>
						</Grid>
						<Grid item xs={2} sm={2}>
							<TextField id="vinnumber" name="vinnumber" label="" fullWidth value={this.state.towfee} onChange={this.handleTowFeeChange} />
						</Grid>
						<Grid item xs={7} sm={7}>
						</Grid>
					
					</Grid>
				)}
				
				
				
				{/* ta2_action_to_notified_immediate */}
				{(this.state.selectedActionOne == "ta2_action_to_notified_immediate") && (<Grid container spacing={24}>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Vehicle Driver/Owner
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1"  >
								{this.message}
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={3} sm={3}>
							<Typography variant="h6" gutterBottom>
								Towing Charges:   $
							</Typography>
						</Grid>
						<Grid item xs={2} sm={2}>
							<TextField id="vinnumber" name="vinnumber" label="" fullWidth value={this.state.towfee} onChange={this.handleTowFeeChange} />
						</Grid>
						<Grid item xs={7} sm={7}>
						</Grid>
					
					</Grid>
				)}
				
				{(this.state.selectedActionOne == "ta3_action_to_notified_time_extension") && (<Grid container spacing={24}>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Vehicle Driver/Owner
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1"  >
								{this.message}
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={3} sm={3}>
							<Typography variant="h6" gutterBottom>
								Towing Charges: $
							</Typography>
						</Grid>
						<Grid item xs={2} sm={2}>
							<TextField id="vinnumber" name="vinnumber" label="" fullWidth value={this.state.towfee} onChange={this.handleTowFeeChange} />
						</Grid>
						<Grid item xs={7} sm={7}>
						</Grid>
						<Grid item xs={3} sm={3}>
							<Typography variant="h6" gutterBottom>
								We can wait for extra
							</Typography>
						</Grid>
						<Grid item xs={1} sm={1}>
							<TextField id="vinnumber" name="vinnumber" label="" fullWidth value={this.state.extratime} onChange={this.handleExtraTimeChange} />
						</Grid>
						<Grid item xs={4} sm={4}>
							<Typography variant="h6" gutterBottom>
								minutes for additional cost of $
							</Typography>
						</Grid>
						<Grid item xs={1} sm={1}>
							<TextField id="vinnumber" name="vinnumber" label="" fullWidth value={this.state.extrafee} onChange={this.handleExtraFeeChange} />
						</Grid>
						<Grid item xs={3} sm={3}>
						</Grid>
					
					
					</Grid>
				)}
				{/* Please note there is no ta4 action. It was illiminated  */}
				
				{/* ta5_action_to_extra_time_granted */}
				{(this.state.selectedActionOne == "ta5_action_to_extra_time_granted") && (<Grid container spacing={24}>
						
						
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Vehicle Driver/Owner.
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1" >
								{this.message}
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6" gutterBottom>
								The towing fee  is ${this.totalAmount}
							</Typography>
						</Grid>
					</Grid>
				)}
				{/* ta6_action_to_moved_by_owner */}
				{(this.state.selectedActionOne == "ta6_action_to_moved_by_owner") && (<Grid container spacing={24}>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Vehicle Driver/Owner
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1" >
								{this.message}
							</Typography>
						</Grid>
						
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6" gutterBottom>
								The driver's credit card  is charged  ${this.totalAmount}
							</Typography>
						</Grid>
					</Grid>
				)}
				{/* Please note there is no ta7  */}
				
				
				{/* ta8_action_to_towed_truck_storage */}
				{(this.state.selectedActionOne == "ta8_action_to_towed_truck_storage") && (<Grid container spacing={24}>
					<Grid item xs={12} sm={12}>
						<Typography variant="h6"  >
							This message will be sent to the Vehicle Driver/Owner
						</Typography>
					</Grid>
					<Grid item xs={12} sm={12} >
						<br/>
					</Grid>
					<Grid>
						{plateLocationStoragelot}
					</Grid>
					<Grid item xs={2} sm={2}>
						<Typography variant="subtitle1" className={classes.detailTitle}>
							Message: <br />
						</Typography>
					</Grid>
					<Grid item xs={10} sm={10}>
						<Typography variant="body1" >
							{this.message}
						</Typography>
					</Grid>
					
					<Grid item xs={12} sm={12} >
						<br/>
					</Grid>
					<Grid item xs={12} sm={12}>
						<Typography variant="h6" gutterBottom>
							The driver's credit card  is charged  ${this.totalAmount}
						</Typography>
					</Grid>
				</Grid>)}
				{/* ta9_action_to_pending_extra_time_granted */}
				{(this.state.selectedActionOne == "ta9_action_to_pending_extra_time_granted") && (<Grid container spacing={24}>
					<Grid item xs={12} sm={12}>
						<Typography variant="h6"  >
							This message will be sent to the Vehicle Driver/Owner
						</Typography>
					</Grid>
					<Grid item xs={12} sm={12} >
						<br/>
					</Grid>
					<Grid>
						{plateLocationStoragelot}
					</Grid>
					<Grid item xs={2} sm={2}>
						<Typography variant="subtitle1" className={classes.detailTitle}>
							Message: <br />
						</Typography>
					</Grid>
					<Grid item xs={10} sm={10}>
						<Typography variant="body1" >
							{this.message}
						</Typography>
					</Grid>
					
					<Grid item xs={12} sm={12} >
						<br/>
					</Grid>
					<Grid item xs={12} sm={12}>
						<Typography variant="h6" gutterBottom>
							The driver's credit card  is charged  ${this.totalAmount}
						</Typography>
					</Grid>
				</Grid>)}
				{/* vo1_cannot_move_action */}
				{(this.state.selectedActionOne == "vo1_cannot_move_action") && (<Grid container spacing={24}>
						
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Tow Agent.
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1" gutterBottom>
								{this.message}
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6" gutterBottom>
								The driver's credit card  is charged  ${this.totalAmount}
							</Typography>
						</Grid>
					</Grid>
				)}
				
				{(this.state.selectedActionOne == "vo2_accepted_one_time_extension_action") && (<Grid container spacing={24}>
						
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Tow Agent.
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1" gutterBottom>
								{this.message}
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6" gutterBottom>
								The driver's credit card  is charged  ${this.totalAmount}
							</Typography>
						</Grid>
					</Grid>
				)}
				{(this.state.selectedActionOne == "vo3_cannot_move_action") && (<Grid container spacing={24}>
						
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Tow Agent.
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1" gutterBottom>
								{this.message}
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6" gutterBottom>
								The driver's credit card  is charged  ${this.totalAmount}
							</Typography>
						</Grid>
					</Grid>
				)}
				
				
				{(this.state.selectedActionOne == "vo4_accepted_multi_time_extension_action") && (<Grid container spacing={24}>
						
						<Grid item xs={12} sm={12}>
							<Typography variant="h6"  >
								This message will be sent to the Tow Agent.
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid>
							{plateLocationStoragelot}
						</Grid>
						<Grid item xs={2} sm={2}>
							<Typography variant="subtitle1" className={classes.detailTitle}>
								Message: <br />
							</Typography>
						</Grid>
						<Grid item xs={10} sm={10}>
							<Typography variant="body1" gutterBottom>
								{this.message}
							</Typography>
						</Grid>
						<Grid item xs={12} sm={12} >
							<br/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<Typography variant="h6" gutterBottom>
								The driver's credit card  is charged  ${this.totalAmount}
							</Typography>
						</Grid>
					</Grid>
				)}
				
				<Grid item xs={10} sm={10} >
					<Typography variant="body1" gutterBottom>
					
					</Typography>
				</Grid>
				<Grid item xs={4} sm={4} >
					{(possibleActions.length !== 0) && (lastMessage !== null) && (lastMessage.state !== MainConstants.COMPLETE_STATE) &&(
						
						<Button onClick={this.handleActionSubmit} className={classes.button}>
							Submit Action
						</Button>)}
					{/*{(possibleActions.length === 0) && (lastMessage !== null) && (lastMessage.state === MainConstants.COMPLETE_STATE) &&(
						<Button onClick={this.handleActionSubmit} className={classes.button}>
							Close wait
						</Button>)}*/}
				</Grid>
				<Grid item xs={4} sm={4} >
					<Typography variant="body1" gutterBottom>
						{this.props.errorCMsg.message}
					</Typography>
				</Grid>
			
			
			</React.Fragment>
		)
			;
	}//end of render
}//End of class

TextVehicleOwner.propTypes = {
	classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
	return {
		messagesArray: state.message.messagesArray,
		saveUserResp: state.user.saveUserResp,
		
		errorCMsg: state.message.errorCMsg,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		loadMessagesData: loadMessagesData,
		saveAMessage: saveAMessage,
		
		
	}, dispatch);
};
//export default withStyles(styles)(TextVehicleOwner);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TextVehicleOwner));
